import React from 'react';
import { withPrefix } from 'gatsby';
import classNames from 'classnames';
import styles from './ImageWithShadow.styles';

const ImageWithShadow = ({ image, ...styleProps }) => (
  <div css={styles(styleProps)}>
    <img
      className={classNames('image image--desktop', {
        'top-left-conner-shadow': styleProps.position === 'left',
        'bottom-right-conner-shadow': styleProps.position === 'right',
      })}
      src={withPrefix(image.desktop)}
      alt="article illustration"
    />
    <img
      className={classNames('image image--mobile', {
        'top-left-conner-shadow--mobile': styleProps.position === 'left',
        'bottom-right-conner-shadow--mobile': styleProps.position === 'right',
      })}
      src={withPrefix(image.mobile)}
      alt="article illustration"
    />
  </div>
);

export default ImageWithShadow;
